import { Eyebrow } from "./eyebrow";

export function SectionHero({
  eyebrow,
  headline,
  body,
}: {
  eyebrow?: string;
  headline?: string;
  body?: string;
}) {
  if (!eyebrow && !headline && !body) return null;
  return (
    <header className="border-l-2 border-primary pl-6 py-2">
      {eyebrow && <Eyebrow className="mb-3">{eyebrow}</Eyebrow>}
      {headline && (
        <h2 className="text-3xl font-semibold tracking-tight leading-tight max-w-2xl">
          {headline}
        </h2>
      )}
      {body && (
        <p className="mt-4 text-base text-muted-foreground leading-relaxed max-w-2xl">{body}</p>
      )}
    </header>
  );
}
